module.exports = __webpack_public_path__ + "dcd6fc65ed9949acd5e99feb26cdd6b2.svg";